module.exports = __webpack_public_path__ + "static/media/lipstickQuestion.54bfc532.png";